'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Seasonality.ClearDemandAdjustment', dependencies).controller('ClearDemandAdjustmentModalController', require('./controllers/ClearDemandAdjustmentModalController')).directive('rmClearDemandAdjustment', require('./directives/ClearDemandAdjustmentModalDirective'));